<template>
  <div
    :class="`reservation ${$store.state.isMobile ? 'reservation_mobile' : 'isPc'} ${$store.state.isMobile && showAdd ? 'onPage' : ''}`">

    <mobileBack type="white" v-show="$store.state.isMobile" :otherClick="showAdd ? true : false"
      @backOtherClick="showAdd = false"></mobileBack>
    <innerWarp v-show="$store.state.isMobile && !showNotice && !showExplaxinInfo" :showAdd="showAdd"
      :addIsUser="addDetail.id == userInfo.id" :teamRe="reservationType == 2">
      <slot>
        <div class="itemWarpType" v-show="!showAdd">
          <div :class="reservationType == 1 ? 'activeType' : ''" @click="reservationType = 1"
            v-if="$store.state.ticketDetail.perOn">个人预约</div>
          <div :class="reservationType == 2 ? 'activeType' : ''" @click="reservationType = 2"
            v-if="$store.state.ticketDetail.orgOn">
            团队预约
          </div>
          <!-- <div class="fileDemo" @click="downFile($store.state.ticketDetail.teamFile)">下载团队凭证模板</div> -->
        </div>

        <!-- 预约日期 -->
        <div class="calendarWarp">
          <!-- <div class="itemContentTitle">预约日期</div> -->
          <div class="calendarTopIcon"></div>
          <div class="calendarDetail" v-if="calendar1.begin.length && $store.state.isMobile">
            <calendar :range="calendar1.range" :events="calendar1.events" :lunar="calendar1.lunar"
              :value="calendar1.value" :begin="calendar1.begin" :end="calendar1.end" :weeks="calendar1.weeks"
              :months="calendar1.months" :disabled="calendar1.disabled" @select="selectDate" ref="calendarDom"
              :isMobile="true"></calendar>
            <div class="itemWarpTime timeWarp" v-if="!closeReservation">
              <div class="contentTitle">入场时间</div>
              <div class="timeInSelected" @click="handelTimeIn">{{ `${selectedDate ? timeIn.label?timeIn.label.includes('可约讲解')?timeIn.label.replace('可约讲解', ''):timeIn.label:'' ||
      '今日预约已结束' : '今日闭馆'}` }}</div>
            </div>
          </div>
        </div>
        <div v-if="closeReservation" class="closeReservation">请选择参观日期</div>
        <!-- 个人预约参观人 -->
        <personal @delData="delData" type="personal" :datas="personals"
          v-if="reservationType == 1 && !closeReservation && selectedDate" @handelShowAdd="handelShowAdd"
          :maxPersonal="maxPersonal" ref="personal" @changeSelectData="changeSelectData" @editPersonal="editPersonal"
          :isMobile="true"></personal>
        <!-- 个人预约儿童 -->
        <personal @delData="delData" type="child" :datas="childs"
          v-if="reservationType == 1 && $store.state.ticketDetail.childrenOn && !closeReservation && selectedDate"
          :maxChildNum="maxChildNum" @handelShowAdd="handelShowAdd" @editPersonal="editPersonal" ref="child"
          :isMobile="true" @selectedHasChild="selectedHasChild" @changeSelectData="changeSelectData"
          @changeChildNumber="changeChildNumber" :fillChildrenInfo="fillChildrenInfo"></personal>
        <!--  <div class="itemCard otherH5Project" style="margin-top: 40px;" v-if="timeInProject.chair || timeInProject.flyingCinema">
          <div :class="`itemWarp ${hasProject == 2 ? 'hasProject' : ''}`">
            <div class="contentTitle">是否预约场馆项目</div>
            <br/>
            <el-radio-group v-model="hasProject">
              <el-radio :label="1">否</el-radio>
              <el-radio :label="2">是</el-radio>
            </el-radio-group>
            <br/>
            <div v-if="hasProject == 2" class="projectWarp">
              <div class="projectTitle">蛋壳椅(最多{{maxProjectNum_c}}位)：</div>
              <el-input v-model="chairNum" type="number" :max="maxProjectNum_c"></el-input>
              <div class="projectTitle">飞行影院(最多{{maxProjectNum_f}}位)：</div>
              <el-input v-model="flyingCinemaNum" type="number" :max="maxProjectNum_f"></el-input>
            </div>
          </div>
        </div> -->
        <!-- 个人须知 -->
        <div class="noticeWarp" v-if="reservationType == 1">
          <div class="itemCard certificate" v-if="$store.state.ticketDetail.imgPersonOn && !closeReservation">
            <span class="contentTitle">请点击上传个人凭证</span>
            <el-upload ref="upload" class="upload-demo" action="1111" accept=".jpg,.png,.jpeg" list-type="picture"
              :http-request="actionImg" multiple :show-file-list="false">
              <div class="buttonText buttonLeft">
                {{ uploadIng ? '上传中' : '点击上传凭证' }}
              </div>
            </el-upload>
            <br />
            <div v-show="certificate.length" class="uploadImgs" v-for="(item, index) in certificate" :key="item">
              <img :src="item" @click="openBigImg(item)">
              <span @click="delImg(index)"></span>
            </div>
          </div>
          <div v-if="$store.state.ticketDetail.personFile" class="fileDemo"
            @click="downFile($store.state.ticketDetail.personFile)">下载个人凭证模板</div>
          <div class="itemWarpLine noticeLine" v-if="!closeReservation">
            <el-checkbox v-model="hasReadNotice" @change="changeReadNotice"></el-checkbox>
            <span :class="`notice ${hasReadNotice ? 'isNoticed' : ''}`" @click="clickNotice">个人预约须知</span>
            <div class="noticeText">请仔细阅读后勾选</div>
          </div>
        </div>
        <!-- 团队信息 -->
        <div v-if="reservationType == 2 && !closeReservation && selectedDate" class="mobileGroupWarp">
          <div class="buttonGroupMobile" v-if="belongData.length">
            <div :class="`itemTitle addGroup ${showAddNewGroup ? 'gray' : ''}`" @click="showAddNewGroup = false">常用团队
            </div>
            <div :class="`itemTitle addGroup ${!showAddNewGroup ? 'gray' : ''}`" style="cursor: pointer;"
              @click="addNewGroup">新增团队</div>
          </div>
          <div class="itemCard">
            <div class="itemCardTitle">团队信息</div>
            <div class="lineContent mobileGroups" v-if="belongData.length && !showAddNewGroup">
              <div class="nameWarp personal">
                <div v-for="group in belongData" @click="selectGroup(group)" :key="group.id"
                  :class="`nameBlock ${group.id == selectGroupId ? 'selected' : ''}`">{{ group.orgName }}</div>
              </div>
            </div>
            <team :team="team" :showAddNewGroup="showAddNewGroup" :museumCode="museumCode"></team>
            <div v-if="showAddNewGroup && !selectGroupId" class="explain"
              style="padding: 0; border-top: 0.026rem solid #BBA988; padding-top: 0.4rem; margin-top: 0.3rem;margin-bottom: 0.4rem">
              <span class="contentTitle" style="font-size: 0.4rem;">设为常用团队</span>
              <el-radio-group v-model="team.common" style="margin-top: 0.15rem">
                <el-radio :label="false">否</el-radio>
                <el-radio :label="true">是</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div v-if="!$store.state.ticketDetail.teamInfoRegister && reservationType == 2 && !closeReservation" class="itemCard teamNumber">
          <div class="lineContent">
            <div class="name">团队人数</div>
            <el-input v-model="teamNumber" placeholder="请输入团队人数" type="number"></el-input>
          </div>
        </div>
        <div v-if="!closeReservation && reservationType == 2">
          <div
            v-if="$store.state.ticketDetail.explainOn && (!$store.state.ticketDetail.teamInfoRegister || isFid) && maxExplainNum != 'no'">
            <div :class="`itemCard explain`">
              <div class="itemCardTitle">
                <div>{{ museumCode == 212594 ? '专人讲解' : '语音讲解' }}</div>
              </div>
              <span class="contentTitle">是否需要讲解</span>
              <!-- {{needExplain}} -->
              <el-radio-group v-model="needExplain" :disabled="!maxExplainNum" style="margin-top: 0.15rem;">
                <el-radio :label="1">否</el-radio>
                <el-radio :label="2">是<span v-if="maxExplainNum != 'no'">(该时段剩余{{ maxExplainNum
                    }})</span></el-radio>
              </el-radio-group>
              <el-input v-model="explainPerNum" placeholder="请输入需要讲解的人数" type="number" :max="maxExplainNum" class="explainPerNumInput" v-if="needExplain == 2 && timeIn.voiceType == 1"></el-input>
              <div class="explainInfo" v-if="explainInfo" @click="openExplainInfo">查看讲解说明</div>
            </div>
          </div>

          <div v-if="museumCode != 212594">
            <div :class="`itemCard certificate ${$store.state.isMobile ? 'isMobile' : ''}`"
              v-if="$store.state.ticketDetail.imgOrgOn">
              <div class="itemCardTitle">请上传团队凭证</div>
              <el-upload ref="upload" class="upload-demo" action="1111" accept=".jpg,.png,.jpeg" list-type="picture"
                :http-request="actionImg" multiple :show-file-list="false">
                <div class="buttonText buttonLeft">
                  {{ uploadIng ? '上传中' : '点击上传凭证' }}
                </div>
              </el-upload>
              <!--   -->
              <br />
              <div v-show="certificate.length" class="uploadImgs" v-for="(item, index) in certificate" :key="item">
                <img :src="item" @click="openBigImg(item)">
                <span @click="delImg(index)"></span>
              </div>
              <!--  <div v-if="hasUpload" class="buttonText hasUpload">已上传</div>
            <div v-if="hasUpload" class="buttonText cancelUpload" @click="hasUpload = false">取消</div> -->
            </div>
            <div v-if="$store.state.ticketDetail.teamFile" class="fileDemo"
              @click="downFile($store.state.ticketDetail.teamFile)">下载团队凭证模板</div>
          </div>
          <div v-if="museumCode == 212594 && needExplain == 2">
            <div :class="`itemCard certificate ${$store.state.isMobile ? 'isMobile' : ''}`"
              v-if="$store.state.ticketDetail.imgOrgOn">
              <div class="itemCardTitle">请上传团队凭证(盖章预约函及名单附件)</div>
              <!-- <el-upload ref="upload" class="upload-demo" action="1111" accept=".jpg,.png,.jpeg,.doc,.docx,.pdf"  -->
              <!-- list-type="picture" -->
              <el-upload ref="upload" class="upload-demo" action="1111" accept=".jpg,.png,.jpeg,.doc,.docx,.pdf"
                :http-request="actionImg" multiple :show-file-list="false">
                <div class="buttonText buttonLeft">
                  {{ uploadIng ? '上传中' : '点击上传凭证' }}
                </div>
                <!-- list-type="picture" -->
              </el-upload>
              <!--   -->
              <br />
              <div v-show="certificate.length" class="uploadImgs" v-for="(item, index) in certificate" :key="item">
                <img :src="item" @click="openBigImg(item)">
                <span @click="delImg(index)"></span>
              </div>
              <!--  <div v-if="hasUpload" class="buttonText hasUpload">已上传</div>
            <div v-if="hasUpload" class="buttonText cancelUpload" @click="hasUpload = false">取消</div> -->
            </div>
            <div v-if="$store.state.ticketDetail.teamFile" class="fileDemo"
              @click="downFile($store.state.ticketDetail.teamFile)">下载团队凭证模板</div>
          </div>
          <div class="itemWarpLine noticeLine" v-if="$store.state.isMobile">
            <el-checkbox v-model="hasReadNotice" @change="changeReadNotice"></el-checkbox>
            <span :class="`notice ${hasReadNotice ? 'isNoticed' : ''}`" @click="clickNotice">预约须知</span>
            <div class="noticeText">请仔细阅读后勾选</div>
          </div>
        </div>
        <!-- 团队预约须知 -->
        <div class="buttonNormalContain" @click="handelButton(reservationType)"
          v-if="!closeReservation && reservationType">{{ reservationType == 1 ||
      !$store.state.ticketDetail.teamInfoRegister ? '确认预约' : '创建团队订单' }}</div>

        <!-- 新增or编辑 -->
        <addCard v-if="showAdd" @handelShowAdd="handelShowAdd" @saveAddPerson="saveAddPerson" :cardTypes="cardTypes"
          :addDetail="addDetail" :addType="addType" :editDetaiType="editDetaiType" :personals="personals"
          @changeAddDetail="changeAddDetail" :hideBottomBack="true" :addIsUser="addDetail.id == userInfo.id"></addCard>
      </slot>
    </innerWarp>
    <van-popup v-model="showPopup" position="bottom">
      <van-picker title="入场时间" show-toolbar :columns="timeOptions" @confirm="onConfirm" @cancel="onCancel"
        @change="onChange" :value-key="'label'" />
    </van-popup>
    <!-- pc端 -->
    <div v-show="!$store.state.isMobile">
      <div class="pcBg"></div>
      <topBanner></topBanner>
      <div class="pcContent handelBlock">
        <div class="buttonLine">
          <div class="buttonRed">
            <el-select v-model="reservationType">
              <el-option :value="1" label="个人" v-if="$store.state.ticketDetail.perOn"></el-option>
              <el-option :value="2"
                :label="`团队${`${$store.state.ticketDetail.orgNumMin ? `(${$store.state.ticketDetail.orgNumMin}~${$store.state.ticketDetail.orgNumMax})人` : ''}`}`"
                v-if="$store.state.ticketDetail.orgOn"></el-option>
            </el-select>
          </div>
          <div class="buttonWhite" @click="toOrders">{{ isFid ? '个人中心' : '我的订单' }}</div>
          <div class="pcToIndex" @click="toIndex">返回</div>
        </div>
        <div class="line" v-if="$store.state.ticketDetail.timeOpen">
          开馆时间<span>{{ $store.state.ticketDetail.timeOpen }}-{{ $store.state.ticketDetail.timeClose }}</span>
          <div class="pcStopTime" v-if="$store.state.ticketDetail.timeStop">停止入馆时间</div>
          <span v-if="$store.state.ticketDetail.timeStop">{{ $store.state.ticketDetail.timeStop }}</span>
        </div>
        <div class="pcItemCard">
          <div class="itemTitle">预约日期</div>
          <div class="pcCalendar" v-if="calendar1.begin.length && !$store.state.isMobile">
            <calendar :range="calendar1.range" :events="calendar1.events" :lunar="calendar1.lunar"
              :value="calendar1.value" :begin="calendar1.begin" :end="calendar1.end" :weeks="calendar1.weeks"
              :months="calendar1.months" :disabled="calendar1.disabled" @select="selectDate" :isMobile="false"
              ref="calendarDom"></calendar>
          </div>
          <div v-if="!closeReservation" class="timeDetail">
            <div class="itemTitle">入场时间</div>
            <div
              :class="`timeAndTicket ${selectedTimeIndex == index ? 'selectedTime' : ''} ${item.label.indexOf('余票') > -1 ? '' : 'oneLine'}`"
              v-for="(item, index) in timeOptions" :key="index" @click="selectTime(item, index)">
              <div v-if="item.label">{{ item.label.split(' ')[0] }}</div>
              <div v-if="item.label&& museumCode == 212594">{{ item.label.split(' ')[1] }}{{((item.voiceNum - item.explainCount) && reservationType == 2) ?'（可约讲解）':''}}</div>
              <div v-if="item.label&& museumCode != 212594">{{ item.label.split(' ')[1] }}</div>
            </div>
            <div style="font-size: 28px; text-align: center;" v-if="!timeOptions.length">{{ !selectedDate ? '今日闭馆' :
      '今日预约已结束' }}</div>
          </div>
          <div v-else class="closeReservation">请选择参观日期</div>
        </div>
        <personal @delData="delData" type="personal" :datas="personals"
          v-show="reservationType == 1 && !closeReservation && selectedDate" @handelShowAdd="handelShowAdd"
          :maxPersonal="maxPersonal" ref="personal" :isMobile="false" @changeSelectData="changeSelectData"
          @editPersonal="editPersonal">
          <slot>
            <div class="itemTitle">请选择参观人<span v-if="maxPersonal"></span>（最多{{ maxPersonal }}人）</div>
          </slot>
        </personal>
        <personal @delData="delData" type="child" :datas="childs" :maxChildNum="maxChildNum"
          v-if="reservationType == 1 && $store.state.ticketDetail.childrenOn && !closeReservation && selectedDate"
          @handelShowAdd="handelShowAdd" ref="child" :isMobile="false" @editPersonal="editPersonal"
          @selectedHasChild="selectedHasChild" @changeSelectData="changeSelectData" style="margin-bottom: 40px;"
          @changeChildNumber="changeChildNumber" :fillChildrenInfo="fillChildrenInfo"></personal>
        <!-- <div class="itemCard otherPcProject" v-if="timeInProject.chair || timeInProject.flyingCinema" :style="`margin: 0.2rem 0;${hasProject == 2 ? 'padding-bottom: 70px' : ''}`">
          <div class="itemWarp">
            <div class="contentTitle">是否预约场馆项目</div>
            <el-radio-group v-model="hasProject">
              <el-radio :label="1">否</el-radio>
              <el-radio :label="2">是</el-radio>
            </el-radio-group>

            <div v-if="hasProject == 2" class="projectWarp">
              <div class="projectTitle">蛋壳椅(最多{{maxProjectNum_c}}位)：</div>
              <el-input v-model="chairNum" type="number" :max="maxProjectNum_c"></el-input>
              <div class="projectTitle">飞行影院(最多{{maxProjectNum_f}}位)：</div>
              <el-input v-model="flyingCinemaNum" type="number" :max="maxProjectNum_f"></el-input>
            </div>
          </div>
        </div> -->
        <!-- 个人凭证 -->
        <div class="itemCard pcItemCard"
          v-if="reservationType == 1 && $store.state.ticketDetail.imgPersonOn && !closeReservation">
          <div class="itemWarpLine certificate" style="margin-left: -0.06rem">
            <span class="contentTitle">请点击上传个人凭证</span>
            <el-upload ref="upload2" class="upload-demo" action="1111" accept=".jpg,.png,.jpeg" list-type="picture"
              :http-request="actionImg" multiple :show-file-list="false">
              <div class="buttonText buttonLeft">
                {{ uploadIng ? '上传中' : '点击上传凭证' }}
              </div>
            </el-upload>
            <span v-if="$store.state.ticketDetail.personFile" class="fileDemo"
              @click="downFile($store.state.ticketDetail.personFile)">下载个人凭证模板</span>
            <br />
          </div>
          <div v-show="certificate.length" class="uploadImgs" v-for="(item, index) in certificate" :key="item">
            <img :src="item" @click="openBigImg(item)">
            <span @click="delImg(index)"></span>
          </div>
        </div>
        <div class="noticeWarp" v-if="reservationType == 1 && !closeReservation">

          <div class="itemWarpLine">
            <el-checkbox v-model="hasReadNotice" @change="changeReadNotice"></el-checkbox>
            <span :class="`notice ${hasReadNotice ? 'isNoticed' : ''}`" @click="clickNotice">个人预约须知</span>
            <div class="noticeText">请仔细阅读后勾选</div>
          </div>
        </div>
        <div class="itemCard pcItemCard" v-if="reservationType == 2 && !closeReservation">
          <!-- <div class="contentTitle">团队信息</div> -->
          <div class="buttonGroup">
            <div :class="`itemTitle addPcGroup ${showAddNewGroup ? 'gray' : ''}`" v-if="belongData.length"
              @click="showAddNewGroup = false">选择常用团队</div>
            <div :class="`itemTitle addPcGroup ${!showAddNewGroup ? 'gray' : ''}`" style="cursor: pointer;"
              @click="addNewGroup" v-if="belongData.length">新增团队</div>
          </div>
          <div v-show="belongData.length && !showAddNewGroup">
            <div class="itemTitle">选择常用团队</div>
            <div v-for="(item) in belongData" :key="item.id"
              :class="`groupItem ${item.id == selectGroupId ? 'activeGroup' : ''}`" @click="selectGroup(item)">
              {{ item.orgName }}</div>
          </div>
          <!-- <div v-if="selectGroupId">
            <div class="itemTitle">团队信息</div>
            <div class="lineContent" style="margin-bottom: 0.2rem;">
              <div class="name">团队负责人</div>
              <div style="text-align: left;">&nbsp;{{$store.state.selectGroup.personName}}</div>
              <div class="name" style="margin-left: 40px; width: 130px">证件号码</div>
              <div style="text-align: left;">&nbsp;{{$store.state.selectGroup.cardNum}}</div>
              <div class="name" style="margin-left: 40px; width: 130px">联系电话</div>
              <div style="text-align: left;">&nbsp;{{$store.state.selectGroup.phone}}</div>
            </div>
          </div> -->
          <div class="itemTitle">团队信息</div>
          <div class="lineBgc" style="display: block;">
            <div class="left" style="margin-right: 0px;display: inline-block;">
              <div :class="`lineContent ${team.showLine ? 'showLine' : ''}`">
                <div class="name nameSpace">团队名称</div>
                <el-input v-model="team.orgName" placeholder="请输入团队名称"  :disabled="!showAddNewGroup"
                  oninput="if(value && value.length>20)value=value.slice(0,20)"></el-input>
              </div>
              <div class="lineContent">
                <div class="name">团队负责人</div>
                <el-input v-model="team.personName" placeholder="请输入团队负责人"
                  :disabled="team.disabled || selectGroupId"></el-input>
              </div>
              <!-- <div class="lineContent lastLine">
                <div class="name">成员信息</div>
                <div class="buttonText buttonLeft" @click="uploadModel">下载模板</div>
              </div> -->
            </div>
            <div class="right" style="margin-right: 0px;margin-left: 80px;display: inline-block;padding-right: 0">
              <div class="lineContent">
                <div class="name">证件号码</div>
                <el-input v-model="team.cardNum" placeholder="请输入证件号码"
                  :disabled="team.disabled || selectGroupId"></el-input>

                <!-- <el-input v-model="team.cardNum" placeholder="请输入证件号码" :disabled="team.disabled && team.cardType == 1 || selectGroupId"></el-input> -->
              </div>
              <div class="lineContent">
                <div class="name nameSpace">联系电话</div>
                <el-input v-model="team.phone" placeholder="请输入联系电话"
                  :disabled="team.disabled || selectGroupId"></el-input>
              </div>
            </div>
          </div>
          <div class="lineContent" style="margin-bottom: 10px" v-if="!$store.state.ticketDetail.teamInfoRegister">
            <div class="contentTitle" style="margin-bottom: 0; padding-left: 45px;">团队人数</div>
            <el-input v-model="teamNumber" placeholder="请输入团队人数" type="number"></el-input>
          </div>
          <div v-if="reservationType == 2" class="itemCard teamNumber">
            <div class="itemWarpLine certificate" style="margin: 0 0" v-if="showAddNewGroup && !selectGroupId">
              <span class="contentTitle">是否设为常用团队</span>
              <el-radio-group v-model="team.common" style="margin-left: 50px;">
                <el-radio :label="false">否</el-radio>
                <el-radio :label="true">是</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="itemCard pcItemCard" style="margin-top: 40px;"
          v-if="reservationType == 2 && !closeReservation && selectedDate">
          <div class="itemCard teamNumber">
            <div class="itemWarpLine" style="margin: 0 0"
              v-if="(!$store.state.ticketDetail.teamInfoRegister || isFid) && $store.state.ticketDetail.explainOn && (maxExplainNum != 'no')">
              <span class="contentTitle explain">是否需要讲解</span>
              <el-radio-group v-model="needExplain" :disabled="!maxExplainNum ? true : false" style="margin-left:115px">
                <el-radio :label="1">否</el-radio>
                <el-radio :label="2">是<span v-if="maxExplainNum != 'no'">(该时段剩余{{ maxExplainNum
                    }})</span></el-radio>
              </el-radio-group>
              <el-input v-model="explainPerNum" placeholder="请输入需要讲解的人数" type="number" :max="maxExplainNum" class="explainPerNumInput" v-if="needExplain == 2 && timeIn.voiceType == 1"></el-input>
            </div>
            <div class="explainInfo"
              v-if="(!$store.state.ticketDetail.teamInfoRegister || isFid) && $store.state.ticketDetail.explainOn && (maxExplainNum != 'no')"
              @click="openExplainInfo">查看讲解说明</div>
            <div class="itemWarpLine certificate" v-if="needExplain==2&&$store.state.ticketDetail.imgOrgOn&&museumCode == 212594&&(!$store.state.ticketDetail.teamInfoRegister || isFid) && $store.state.ticketDetail.explainOn && (maxExplainNum != 'no')">
              <span class="contentTitle">请上传团队凭证图片</span>
              <el-upload ref="upload2" class="upload-demo" action="1111" accept=".jpg,.png,.jpeg" list-type="picture"
                :http-request="actionImg" multiple :show-file-list="false">
                <div class="buttonText buttonLeft">
                  {{ uploadIng ? '上传中' : '点击上传凭证' }}
                </div>
              </el-upload>
              <span v-if="$store.state.ticketDetail.teamFile" class="fileDemo"
                @click="downFile($store.state.ticketDetail.teamFile)">下载团队凭证模板</span>
              <br />
            </div>
            <div class="itemWarpLine certificate" v-if="$store.state.ticketDetail.imgOrgOn&&museumCode != 212594">
              <span class="contentTitle">请上传团队凭证图片</span>
              <el-upload ref="upload2" class="upload-demo" action="1111" accept=".jpg,.png,.jpeg" list-type="picture"
                :http-request="actionImg" multiple :show-file-list="false">
                <div class="buttonText buttonLeft">
                  {{ uploadIng ? '上传中' : '点击上传凭证' }}
                </div>
              </el-upload>
              <span v-if="$store.state.ticketDetail.teamFile" class="fileDemo"
                @click="downFile($store.state.ticketDetail.teamFile)">下载团队凭证模板</span>
              <br />
            </div>
            <div v-show="certificate.length" class="uploadImgs" v-for="(item, index) in certificate" :key="item">
              <img :src="item" @click="openBigImg(item)">
              <span @click="delImg(index)"></span>
            </div>
            <div class="itemWarpLine" style="display: block; text-align: center;"
              v-if="!$store.state.ticketDetail.teamInfoRegister">
              <el-checkbox v-model="hasReadNotice" @change="changeReadNotice"></el-checkbox>
              <span :class="`notice ${hasReadNotice ? 'isNoticed' : ''}`" @click="clickNotice">预约须知</span>
              <div class="noticeText">请仔细阅读后勾选</div>
            </div>
          </div>
        </div>
        <div :class="`button3 ${!$store.state.isMobile ? 'pcButton3' : ''}`" @click="handelButton(1)"
          v-if="reservationType == 1 && !closeReservation">确认预约</div>
        <div class="buttonsWarp" v-if="reservationType == 2 && !closeReservation">
          <!-- <el-upload
            v-if="!hasModel && $store.state.ticketDetail.teamInfoRegister"
            class="upload-demo"
            action="1111"
            ref="uploadModel"
            :http-request="actionModel"
            :limit="1"
            :show-file-list="false">
            <div class="button4">上传模板</div>
          </el-upload> -->
          <div class="button3" @click="handelButton(2)" v-if="reservationType == 2">
            {{ $store.state.ticketDetail.teamInfoRegister ? '创建团队订单' : '确认预约' }}</div>
        </div>
        <pop v-if="showAdd" :editDetaiType="editDetaiType">
          <slot>
            <div class="popContent">
              <div class="popCloseIcon" @click="showAdd = false" v-if="userInfo.id"></div>
              <div class="title">{{ addType == 'personal' ? (personals.length ? '添加成员' : '完善您的个人信息') : '添加儿童信息' }}</div>
              <div class="baseLine"></div>
              <div class="lineContent">
                <div class="name">姓<span></span>名</div>
                <el-input v-model="addDetail.personName" placeholder="请输入姓名"
                  oninput="if(value.length>20)value=value.slice(0,20)"></el-input>
              </div>
              <div v-if="addType == 'personal'">
                <div class="lineContent">
                  <div class="name">证件类型</div>
                  <el-select v-model="addDetail.cardType" placeholder="请选择">
                    <!-- {{ cardTypes }} -->
                    <el-option v-for="item in cardTypes" :key="item.val" :label="item.name" :value="item.val">
                    </el-option>
                  </el-select>
                </div>
                <div class="lineContent">
                  <div class="name">证件号码</div>
                  <el-input v-model="addDetail.cardNum" placeholder="请输入证件号码"></el-input>
                </div>
                <div class="lineContent">
                  <div class="name">联系电话</div>
                  <el-input v-model="addDetail.phone" placeholder="请输入联系电话" type="number"
                    oninput="if(value.length>11)value=value.slice(0,11)" :disabled="addDetail.phoneDisabled"></el-input>
                </div>
              </div>
              <div v-else>
                <div class="lineContent" v-if="$store.state.ticketDetail.childCardNumOn">
                  <div class="name">证件号码</div>
                  <el-input v-model="addDetail.cardNum" placeholder="请输入证件号码"></el-input>
                </div>
                <div class="lineContent">
                  <div class="name">年龄（岁）</div>
                  <el-input v-model="addDetail.age" placeholder="请输入年龄" type="number"></el-input>
                </div>
                <div class="lineContent">
                  <div class="name">性<span></span>别</div>
                  <el-radio-group v-model="addDetail.gender">
                    <el-radio :label="1">男</el-radio>
                    <el-radio :label="2">女</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="tips" v-if="addDetail.haveOrder">该用户有过历史订单，暂不支持修改基本信息</div>
              <div class="buttonConfirm" @click="!addDetail.haveOrder ? saveAddPerson(addDetail) : showAdd = false">
                {{ !addDetail.haveOrder ? '保存' : '关闭' }}</div>
              <!-- <div class="buttonConfirm" @click="saveAddPerson(addDetail)">{{!addDetail.haveOrder ? '保存' : '关闭'}}</div> -->
            </div>
          </slot>
        </pop>
      </div>
    </div>
    <temp v-if="showTemp" :imgUrl="tempImgUrl"></temp>
    <notice v-if="(showExplaxinInfo || showNotice) && $store.state.isMobile" :readTime="readTime"
      :showExplaxinInfo="showExplaxinInfo" :explainInfo="explainInfo"></notice>
    <pop v-if="(showExplaxinInfo || showNotice) && !$store.state.isMobile">
      <slot>
        <div class="popContent popNoticeContent">
          <div class="popContentTitle">预约须知</div>
          <div class="popNotice" v-html="showExplaxinInfo ? explainInfo : $store.state.ticketDetail.bookingNote">
          </div>
        </div>
        <div class="buttonWarp">
          <div :class="`buttonConfirm popHasRead ${readTime && !showExplaxinInfo ? 'gayText' : ''}`" @click="hasRead">
            已读{{ readTime && !showExplaxinInfo ? `(${readTime}s)` : '' }}</div>
        </div>
      </slot>
    </pop>
    <div class="bigImg" v-if="showBigImg">
      <div class="placeholder" @click="showBigImg = false"></div>
      <div class="imgWarp">
        <img :src="bigImgUrl">
      </div>
    </div>
  </div>
</template>

<script>
import innerWarp from '../../components/common/innerWarp.vue'
import calendar from "@/components/calendar/calendar.vue";
import mobileBack from '../../components/common/mobileBack'
import personal from '@/components/ticket/personal';
import team from '@/components/ticket/team'
import addCard from '@/components/ticket/addCard'
import topBanner from '../../components/common/topBanner'
import pop from '../../components/common/pop'
import notice from '../../components/common/notice.vue'
import temp from '../../components/common/temp.vue'
import Popup from 'vant/lib/popup';
import 'vant/lib/popup/style';
import Picker from 'vant/lib/picker';
import 'vant/lib/picker/style';
var timeInterval
export default {
  data() {
    return {
      calendar1: {
        range: false,
        value: [],
        disabled: ["2019", "8", "3"],
        // lunar:true, //显示农历
        weeks: ["日", "一", "二", "三", "四", "五", "六"],
        months: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月"
        ],
        events: {
          '2022,3,2': '闭馆'
        },
        begin: [], //可选开始日期
        end: [], //可选结束日期
      },
      reservationType: '', //预约类型
      timeIn: '',//入场时间value
      timeOptions: [], //入场时间及余票数
      selectedTimeIndex: -1, //选中的入场时间index
      personals: [],//参观人可选列表
      showAdd: false, //开启添加成员
      team: {
        common: false
      },
      childs: [], //儿童列表
      maxChildNum: 0, //携带儿童计算的最大数
      personalHasChild: 2, //每个参观人可携带的儿童
      addDetail: {},
      cardTypes: [
        { name: '身份证', val: 1 },
        { name: '护照（Passport）', val: 2 },
        { name: '台胞证', val: 5 },
        { name: '军官证', val: 6 },
        { name: '外国人永居证', val: 7 },
        { name: '港澳居民来往内地通行证', val: 3 },
      ],
      addType: '', //新增类型 personal 个人信息 child 儿童
      hasReadNotice: false, //须知已读
      showTemp: false,
      editDetaiType: 'add',
      showNotice: false,
      showPopup: false,
      museumCode: '',
      belongData: [],
      belongId: '',
      selectGroupId: undefined,
      selectedDate: '',
      showAddNewGroup: false,
      otherData: '',
      fromData: {},
      hasModel: false,
      selectPersons: [],
      selectChilds: [],
      hasChild: 1,
      closeReservation: false,
      needExplain: 1,
      maxExplainNum: 0,
      certificate: [],
      uploadIng: false,
      teamNumber: '',
      showBigImg: false,
      bigImgUrl: '',
      hasClick: false,
      flyingCinemaNum: '',
      chairNum: '',
      hasProject: 1,
      maxProjectNum_c: 0,
      maxProjectNum_f: 0,
      hasOpenNotice: false,
      userInfo: {},
      isFid: false,
      readTime: 3,
      timeInProject: {},
      childNumber: '', //不需要儿童信息的时候儿童数量
      fillChildrenInfo: true, //是否需要儿童信息 兼容老平台的数据，默认为显示
      explainInfo: '',//讲解说明
      showExplaxinInfo: false, //讲解说明开启
      loadingTimeDetail: false,
      tempImgUrl: '',
      // maxExplainNum: '', //最大讲解人数
      explainPerNum: '',//讲解人数
    };
  },

  components: {
    innerWarp,
    calendar,
    personal,
    team,
    addCard,
    topBanner,
    pop,
    notice,
    temp,
    'van-popup': Popup,
    'van-picker': Picker,
    mobileBack
  },

  methods: {
    // 打开讲解说明
    openExplainInfo() {
      this.showExplaxinInfo = true
    },
    // 修改儿童数量
    changeChildNumber(value) {
      this.childNumber = value
    },
    // 点击预约须知
    changeReadNotice() {
      if (!this.hasOpenNotice) this.showNotice = true
    },

    onSuccess(res, file) {

    },

    openBigImg(item) {
      this.showBigImg = true
      this.bigImgUrl = item
    },

    delImg(index) {
      this.certificate.splice(index, 1)
    },

    actionImg(params) {
      this.uploadIng = true
      let formData = new FormData();
      let museumCode = this.$cookie.get('museumCode') || this.$route.query.museumCode
      formData.append("file", params.file);
      formData.append('folder', `${museumCode}/newTicket`)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$ajax.post('/api/file/upload/single', formData, config).then((res) => {
        console.log('res')
        console.log(res)
        this.uploadIng = false
        // let url = 
        // alert(JSON.stringify(res))
        // alert(JSON.stringify(res.data))
        // alert(this.$cookie.get('_uid'))
        // alert(this.$cookie.get('fid'))
        this.certificate.push(res.data.http.replace('https://p.ananas.chaoxing.com', 'https://museum.chaoxing.com'))
        this.$refs["upload"].clearFiles();
        this.$refs["upload2"].clearFiles();
      }).catch((res) => {
//                 if (!res) {
//           this.$router.push({ path: '/ticket/login', query: this.$router.app._route.query })
//         } else {

//         }
        this.$refs["upload"].clearFiles();
        this.$refs["upload2"].clearFiles();
      })
    },
    downloadFile(url) {

      if (url.indexOf('http:') === 0) {
        url = url.replace(/http:/g, 'https:')
      }
      url = url.replace('https://d0.ananas.chaoxing.com', 'https://museum.chaoxing.com')
      // 创建一个<a></a >标签
      const a = document.createElement('a');
      a.href = url;
      // 障眼法藏起来a标签
      a.style.display = 'none';
      // 将a标签追加到文档对象中
      document.body.appendChild(a);
      // 模拟点击了<a>标签,会触发<a>标签的href的读取,浏览器就会自动下载了
      a.click();
      // 一次性的,用完就删除a标签
      a.remove();
    },
    isPhotoFormat(url) {
      const photoExtensions = /\.(jpg|jpeg|png|gif|bmp|webp)$/i;
      return photoExtensions.test(url);
    },

    downFile(file) {
      console.log(this.isPhotoFormat(file))
      if (this.isPhotoFormat(file)) {
        this.tempImgUrl = file
        this.showTemp = true
      } else {
        this.downloadFile(file)
      }

    },

    addNewGroup() {
      this.showAddNewGroup = true
      this.selectGroupId = ''
      this.otherData = ''
      this.team.common = false
      if (!this.userInfo.id) return
      this.team.disabled = true
      this.team.phone = this.userInfo.phone
      this.team.personName = this.userInfo.personName
      console.log(this.userInfo.cardType)
      if (this.userInfo.cardType) {
        this.team.cardNum = this.userInfo.cardNum
        this.team.cardType = this.userInfo.cardType
      }
    },
    selectGroup(item) {
      // if (this.selectGroupId == item.id) return this.selectGroupId = undefined
      this.selectGroupId = item.id
      this.selectGroupItem = item
      this.$store.state.selectGroup = item
      this.team = item
    },

    handelTimeIn() {
      this.showPopup = true
    },

    clickNotice() {
      this.showNotice = true
    },
    toOrders() {
      let query = this.$route.query
      query.rType = this.reservationType
      if (this.isFid) return this.$router.push({ path: '/ticket/personalCenter', query })
      this.$router.push({ path: '/ticket/orders', query })
    },

    toIndex() {
      this.$router.push({ path: '/ticket/home', query: this.$route.query })
    },

    selectDate(value) {
      // if (!value[1]) {
      //   // value[0] += 1
      //   value[1] = 12
      // }
      this.selectedDate = value.join('/');
    },

    uploadModel() {
      let text = '团队成员模板.xlsx'
      location.href = encodeURI(location.origin + location.pathname + text)
    },

    // 清除上传团队模板
    clearModelFile() {
      // if (!this.$store.state.ticketDetail.teamInfoRegister && !this.$refs.uploadModel) return 
      // this.$refs.uploadModel.clearFiles()
    },

    getTimeDetail() {
      if (!this.selectedDate) return
      this.closeReservation = false
      this.loadingTimeDetail = true
      this.$ajax(`/api/ticket/front/time-setting?museumCode=${this.museumCode}&date=${this.selectedDate}&ticketId=${this.$store.state.ticketDetail.id || this.$route.query.id}${this.isFid ? `&type=${this.reservationType == 1 ? 0 : 1}` : ''}`).then((res) => {
        if (this.$store.state.ticketDetail.bookingDays == 0) {
          res.data = []
        }
        if (res.data == '该日闭馆。') {
          this.loadingTimeDetail = false
          return this.closeReservation = true
        }
        res.data = res.data.filter((item) => { return item.endTime && item.startTime })
        // 团队是否被限制
        res.data = res.data.filter((item) => { return !((item.teamCountType == 2 && (item.numLimt - item.teamCount <= 0)) || (item.teamCountType == 1 && item.numLimt - item.orderCount <= 0)) })
        // 个人预约的限制
        if (this.reservationType == 1) {
          res.data = res.data.filter((item) => { return !item.numLimt || (item.numLimt - item.orderCount > 0) })
        }
        res.data = res.data.map((item) => {
          item.label = `${item.startTime.substring(0, 5)}-${item.endTime.substring(0, 5)} ${item.numLimt ? `余票${item.numLimt - item.orderCount}` : ''}`
          // item.label = `${item.startTime.substring(0, 5)}-${item.endTime.substring(0, 5)} ${item.numLimt ? `余票${item.numLimt - item.orderCount} ${(this.maxExplainNum != 'no'&&this.reservationType==2)?'可约讲解':''}` : ''}`
          return item
        })
        let date = new Date().getHours() * 3600 + new Date().getMinutes() * 60
        console.log(this.selectedDate)
        let timeD = Date.parse(new Date()) - Date.parse(this.selectedDate.replaceAll('-', '/'))
        if (timeD > 0) { //今天
          this.timeOptions = res.data.filter((item) => {
            return item.endTime.split(':')[0] * 3600 + item.endTime.split(':')[1] * 60 > date
          })
        } else {
          this.timeOptions = res.data
        }

        this.loadingTimeDetail = false
        this.timeIn = this.timeOptions[0] || {}
        this.selectedTimeIndex = 0
        this.maxProjectNum_c = this.timeInProject.chair ? this.timeInProject.chair - this.timeInProject.orderChairCount : 0
        this.maxProjectNum_f = this.timeInProject.flyingCinema ? this.timeInProject.flyingCinema - this.timeInProject.orderFlyingCinemaCount : 0
        if (this.timeIn.voiceType == 1) { //剩余可用的讲解人数
          this.maxExplainNum = this.timeIn.voiceNum - this.timeIn.explainNum
        } else {
          // 最大预约人数
          this.maxExplainNum = this.timeIn.voiceNum ? this.timeIn.voiceNum - this.timeIn.explainCount : 'no'
        }
        console.log('res.data')
        console.log(res.data)
        res.data = res.data.map((item) => {
          // item.label = `${item.startTime.substring(0, 5)}-${item.endTime.substring(0, 5)} ${item.numLimt ? `余票${item.numLimt - item.orderCount}` : ''}`
          item.label = `${item.startTime.substring(0, 5)}-${item.endTime.substring(0, 5)} ${item.numLimt ? `余票${item.numLimt - item.orderCount} ${((item.voiceNum - item.explainCount) && this.reservationType == 2) ? '可约讲解' : `    `}` : ''}`
          return item
        })
      })
    },

    // 提交
    handelButton(type) {
      if (!this.timeIn.id) {
        this.clearModelFile()
        return this.$message.error('请选择入场时间')
      }
      if (type == 2) { //团队预约
        if (!this.$store.state.ticketDetail.teamInfoRegister && !this.teamNumber) return this.$message.error('请输入团队人数！')
        if (this.timeIn.voiceType == 1 && this.needExplain == 2) {
          if (!this.explainPerNum) return this.$message.error('请输入需要讲解的人数！')
          if (this.explainPerNum > this.maxExplainNum) return this.$message.error(`讲解人数不能超过剩余人数！`)
            if (this.explainPerNum > this.teamNumber) return this.$message.error(`讲解人数不能大于团队人数！`)
        }
        if (this.museumCode == 212594) {
          if (this.$store.state.ticketDetail.imgOrgOn && !this.certificate.length && this.needExplain * 1 == 2) {
            this.clearModelFile()
            return this.$message.error('请上传团队凭证')
          }
        } else {
          if (this.$store.state.ticketDetail.imgOrgOn && !this.certificate.length) {
            this.clearModelFile()
            return this.$message.error('请上传团队凭证')
          }
        }

        if (this.selectGroupId) { //选已有的团队
          let maxExplainNum
          if (this.timeIn.voiceType == 1) { //剩余可用的讲解人数
            maxExplainNum = this.timeIn.voiceNum - this.timeIn.explainNum
          } else {
            // 最大预约人数
            maxExplainNum = this.timeIn.voiceNum ? this.timeIn.voiceNum - this.timeIn.explainCount : 'no'
          }
          let query = {
            belongId: this.selectGroupId,
            needExplain: this.needExplain * 1,
            museumName: this.$store.state.museumName,
            museumCode: this.museumCode,
            selectedDate: this.selectedDate,
            timeId: this.timeIn.id,
            timeLabel: this.timeIn.label.split(' ')[0],
            maxExplainNum: maxExplainNum
          }
          if (this.hasProject == 2) { //有项目预约
            let flyingCinemaNum = this.flyingCinemaNum ? parseInt(this.flyingCinemaNum) : 0
            let chairNum = this.chairNum ? parseInt(this.chairNum) : 0
            if (flyingCinemaNum > this.maxProjectNum_f || chairNum > this.maxProjectNum_c) {
              return this.$message.error('场馆预约数量超过最大值，请核对后重新填写')
            }
            query.flyingCinemaNum = flyingCinemaNum
            query.chairNum = chairNum
          }
          if (this.$store.state.ticketDetail.imgOrgOn || this.$store.state.ticketDetail.imgPersonOn) { //需要上传团队或者个人凭证
            query.imgOrgOn = 1
          }

          if (!this.$store.state.ticketDetail.teamInfoRegister) { //团队预约不需要成员直接预约
            return this.directReservation(query)
          }
          let params = {
            certificate: this.certificate
          }
          //微服务的场馆团队预约新接口
          if (this.isFid) return this.newSetOrder(query, params)
          return this.$router.push({ name: 'groupDetail', query, params: params })
        }
        // 新增团队
        if (!this.team.orgName || !this.team.personName || !this.team.phone || !this.team.cardNum) {
          this.clearModelFile()
          // this.$refs.uploadModel.clearFiles();
          return this.$message.error('请选择常用团队或将新建团队信息填写完整！')
        }
        if ((!this.hasReadNotice && this.$store.state.isMobile) || (!this.hasReadNotice && !this.$store.state.isMobile && !this.$store.state.ticketDetail.teamInfoRegister)) return this.$message.error('请阅读并勾选预约须知')
        this.team.personType = 4
        this.team.cardType = 1
        this.postAddPersonal(this.team, 'groupCharge')
      }
      if (type == 1) { //个人预约点击确定
        if (this.$store.state.ticketDetail.imgPersonOn && !this.certificate.length) return this.$message.error('请上传个人凭证')
        // this.selectPersons = selectData : this.selectChilds = selectData
        let peopleIds = this.personals.filter((item, index) => {
          return this.selectPersons.indexOf(index) > -1
        })
        let childs = this.childs.filter((item, index) => {
          return this.selectChilds.indexOf(index) > -1
        })
        // childNumber
        if (!peopleIds.length) return this.$message.error('请选择参观人')
        if (!this.hasReadNotice) return this.$message.error('请阅读并勾选预约须知')
        if (((this.fillChildrenInfo && !childs.length) || (!this.fillChildrenInfo && !this.childNumber)) && this.hasChild == 2) return this.$message.error('您点击了携带儿童，请选择儿童')
        if (this.hasChild == 1) {
          peopleIds = peopleIds.map((item) => { return item.id })
        } else {
          if (this.fillChildrenInfo) {
            peopleIds = peopleIds.map((item) => { return item.id }).concat(childs.map((item) => { return item.id }))
          } else {
            peopleIds = peopleIds.map((item) => { return item.id })
          }
        }
        let data = {
          museumCode: this.museumCode,
          bookingDate: this.selectedDate.replace(/\//g, '-'),
          timeSettingId: this.timeIn.id,
          orderType: 2,
          peopleIds: peopleIds,
          childOn: this.hasChild == 1 ? false : true,
          belongNum: this.hasChild == 2 ? (this.fillChildrenInfo ? this.selectChilds.length : parseInt(this.childNumber)) : undefined,
          ticketInfoId: this.$store.state.ticketDetail.id,
          certificate: this.$store.state.ticketDetail.imgPersonOn || this.$store.state.ticketDetail.imgOrgOn ? this.certificate.join('|') : undefined,
        }
        if (this.hasProject == 2) {
          data.flyingCinemaNum = this.flyingCinemaNum ? parseInt(this.flyingCinemaNum) : 0
          data.chairNum = this.chairNum ? parseInt(this.chairNum) : 0
          if (data.flyingCinemaNum > this.maxProjectNum_f || data.chairNum > this.maxProjectNum_c) {
            return this.$message.error('场馆预约数量超过最大值，请核对后重新填写')
          }
        }
        if (this.hasClick) return
        if (this.isFid) { //新的个人预约
          // return console.log(data)
          this.$ajax.post('/api/ticket/front/order/personal', data).then((res) => {
            this.hasClick = false
            let query = this.$route.query
            query.orderId = res.data
            this.$router.push({ path: '/ticket/re_success', query })
          }).catch((err) => {
            this.hasClick = false
          })
          return
        }
        this.hasClick = true
        this.$ajax.post('/api/ticket/front/order', data).then((res) => {
          this.hasClick = false
          let query = this.$route.query
          query.orderId = res.data
          this.$router.push({ path: '/ticket/re_success', query })
        }).catch((err) => {
          this.hasClick = false
        })
      }
    },

    actionModel(params) {
      this.formData = new FormData();
      // let formData = new FormData();
      this.formData.append("file", params.file);
      if (this.showAddNewGroup) {
        return this.handelButton(this.reservationType)
      }
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      if (!this.selectGroupId) return this.$message.error('请选择团队')
      this.$ajax.post(`/api/ticket/front/people/import-excel?museumCode=${this.museumCode}&belongId=${this.selectGroupId}`, this.formData, config).then((res) => {
        if (res.status == 200) {
          this.hasModel = true
          this.$message.success('上传成功')
        }
      })
    },

    handelShowAdd(data, type, editType) {
      this.addType = type
      this.editDetaiType = editType
      if (type == 'child' && editType == 'add' && this.$store.state.ticketDetail.childCardNumOn) {
        this.addDetail.cardType = 1
      }
      this.showAdd = data
    },

    selectTime(item, index) {
      this.timeIn = item
      if (this.timeIn.voiceType == 1) { //剩余可用的讲解人数
        this.maxExplainNum = this.timeIn.voiceNum - this.timeIn.explainNum
      } else {
        // 最大预约人数
        this.maxExplainNum = this.timeIn.voiceNum ? this.timeIn.voiceNum - this.timeIn.explainCount : 'no'
      }
      console.log('maxExplainNum')
      console.log(this.maxExplainNum)
      this.selectedTimeIndex = index
    },

    // 保存编辑或者新增的数据
    saveAddPerson(data) {
      // if (this.$store.state.ticketDetail.childAgeMin || this.$store.state.ticketDetail.childAgeMax) {
      let ticketDetail = this.$store.state.ticketDetail
      if (this.addType == 'child' && ((ticketDetail.childAgeMax && this.addDetail.age > ticketDetail.childAgeMax) || (ticketDetail.childAgeMin && this.addDetail.age < ticketDetail.childAgeMin))) return this.$message.error(`携带的儿童年龄要求在${ticketDetail.childAgeMin}~${ticketDetail.childAgeMax}岁之间`)
      // }

      if (this.addType == 'personal') {
        if (data.phone && !/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(data.phone)) return this.$message.warning('请输入正确的手机号')
        if (!data.cardNum || !data.personName || !data.phone || !data.cardType) return this.$message.warning('请将基础信息填写完整！')
      } else {
        if (!data.personName || !data.age || !data.gender) return this.$message.warning('请将基础信息填写完整！')
        if (this.$store.state.ticketDetail.childCardNumOn && !data.cardNum) return this.$message.warning('请将基础信息填写完整！')
      }
      if (this.editDetaiType != 'add' && this.editDetaiType != 'addUserInfo') {
        return this.postEditPersonal(data)
      }
      // 个人：2，儿童：3
      this.addType == 'personal' ? data.personType = 2 : data.personType = 3
      this.postAddPersonal(data)
    },

    // 提交编辑
    postEditPersonal(data) {
      console.log(123)
      if (this.hasClick) return
      this.hasClick = true
      this.$ajax.put('/api/ticket/front/people', data).then((res) => {
        this.showAdd = false
        this.hasClick = false
        this.getPeopleInfo(this.belongId, this.addType == 'personal' ? 2 : 3)
      }).catch((error) => {
        this.hasClick = false
      })
    },

    // 提交新增
    postAddPersonal(data, type) {
      data.museumCode = this.museumCode
      if (!type && this.editDetaiType != 'addUserInfo') { //普通的添加（个人列表或者携带儿童）
        data.belongId = this.belongId
      }
      if (type === 'groupCharge') {
        delete data.id;
      }
      if (this.hasClick) return
      this.hasClick = true
      this.$ajax.post('/api/ticket/front/people', data).then((res) => {
        this.hasClick = false
        this.showAdd = false
        if (!this.personals.length) {
          var pat = /(\d{3})\d*(\d{4})/;
          let phone = data.phone.replace(pat, '$1****$2');
          this.$cookie.set('ticket_phone', phone)
        }
        if (!type) {
          if (!this.belongId) {
            location.reload()
          }
          this.getPeopleInfo(this.belongId, this.addType == 'personal' ? 2 : 3)
        } else if (type == 'groupCharge') { //添加团队负责人，后续操作
          this.getBelongInfo(type)
        }
      }).catch((error) => {
        console.log(error)
        this.hasClick = false
        this.clearModelFile()
      })
    },

    // 删除参观人
    delData(index, type) {
      let id = type == 'personal' ? this.personals[index].id : this.childs[index].id
      this.$ajax.delete(`/api/ticket/front/people/${id}`).then((res) => {
        this.getPeopleInfo(this.belongId, type == 'personal' ? 2 : 3)
      })
    },

    changeSelectData(selectData, type) {
      if (type == 'personal') {
        this.maxChildNum = selectData.length * (this.$store.state.ticketDetail.childNumMax || 1)
        return this.selectPersons = selectData
      }
      this.selectChilds = selectData
    },

    editPersonal(index, type) {
      this.addType = type
      this.editDetaiType = index
      this.addDetail.id = type == 'personal' ? this.personals[index].id : this.childs[index].id
      this.showAdd = true
    },

    // 根据id获取未脱敏的数据
    changeAddDetail(res) {
      this.addDetail = res
      if (this.addDetail.phone == this.$store.state.userPhone) {
        this.addDetail.phoneDisabled = true
      }
    },

    onConfirm(value, index) {
      this.timeIn = value
      if (this.timeIn.voiceType == 1) { //剩余可用的讲解人数
        this.maxExplainNum = this.timeIn.voiceNum - this.timeIn.explainNum
      } else {
        // 最大预约人数
        this.maxExplainNum = this.timeIn.voiceNum ? this.timeIn.voiceNum - this.timeIn.explainCount : 'no'
      }
      this.showPopup = false
    },
    onChange(picker, value, index) {
    },
    onCancel() {
      this.showPopup = false
    },

    getBelongInfo(type) {
      this.$ajax(`/api/ticket/front/people/belong-info?museumCode=${this.museumCode}&personType=${this.reservationType == 1 ? 2 : 4}`).then((res) => {
        let t = !res.data || !res.data.length
        if (t && this.reservationType == 1) {
          return
        }
        this.belongData = res.data
        if (!this.belongData.length) this.addNewGroup()
        if (this.belongData.length && !this.$cookie.get('ticket_phone')) {
          var pat = /(\d{3})\d*(\d{4})/;
          let phone = this.belongData[0].phone.replace(pat, '$1****$2');
          this.$cookie.set('ticket_phone', phone)
        }
        if (type == 'groupCharge') {
          // 没有上传成员模板提交
          this.$store.state.selectGroup = this.belongData[this.belongData.length - 1]
          let maxExplainNum
          if (this.timeIn.voiceType == 1) { //剩余可用的讲解人数
            maxExplainNum = this.timeIn.voiceNum - this.timeIn.explainNum
          } else {
            // 最大预约人数
            maxExplainNum = this.timeIn.voiceNum ? this.timeIn.voiceNum - this.timeIn.explainCount : 'no'
          }
          let query = {
            belongId: this.belongData[this.belongData.length - 1].id,
            museumCode: this.museumCode,
            selectedDate: this.selectedDate,
            timeId: this.timeIn.id,
            timeLabel: this.timeIn.label.split(' ')[0],
            needExplain: this.needExplain * 1,
            maxExplainNum: maxExplainNum
          }
          if (this.$store.state.ticketDetail.imgOrgOn || this.$store.state.ticketDetail.imgPersonOn) {
            query.imgOrgOn = 1
          }

          if (!this.$store.state.ticketDetail.teamInfoRegister) { //不需要成员直接预约
            return this.directReservation(query)
          }
          let params = {
            certificate: this.certificate
          }
          //微服务的场馆团队预约新接口
          if (this.isFid) return this.newSetOrder(query, params)
          return this.$router.push({ name: 'groupDetail', query, params })
        }
        this.belongId = this.belongData[0] ? this.belongData[0].id : ''
        this.getPeopleInfo(this.belongId, this.reservationType == 1 ? 2 : 1)
      })
    },
    // 微服务的新的上传团队
    newSetOrder(query, params) {
      console.log('query')
      console.log(query)
      if (this.hasClick) return
      this.hasClick = true
      let data = {
        museumCode: this.museumCode,
        bookingDate: query.selectedDate.replace(/\//g, '-'),
        timeSettingId: query.timeId,
        orderType: 1,
        peopleIds: [query.belongId],
        explainOn: query.needExplain * 1 == 2 ? true : false,
        certificate: query.imgOrgOn ? this.certificate.join('|') : undefined,
        ticketInfoId: this.$store.state.ticketDetail.id,
        explainNum: this.explainPerNum || undefined
      }
      this.$ajax.post('/api/ticket/front/order/temp', data).then((res) => {
        this.hasClick = false
        let querys = this.$route.query
        querys.orderId = res.data
        querys.belongId = query.belongId
        this.$router.push({ path: '/ticket/groupDetail', query: querys })
      }).catch((err) => {
        this.hasClick = false
      })
    },

    // 不需要成员信息，直接生成订单
    directReservation(query) {
      if (this.hasClick) return
      this.hasClick = true
      console.log('query')
      console.log(query)
      let data = {
        museumCode: this.museumCode,
        bookingDate: query.selectedDate.replace(/\//g, '-'),
        timeSettingId: query.timeId,
        orderType: 1,
        peopleIds: [query.belongId],
        explainOn: query.needExplain * 1 == 2 ? true : false,
        belongNum: this.teamNumber,
        certificate: query.imgOrgOn ? this.certificate.join('|') : undefined,
        ticketInfoId: this.$store.state.ticketDetail.id,
        explainNum: this.explainPerNum || undefined
      }
      if (this.hasProject == 2) {
        data.flyingCinemaNum = this.flyingCinemaNum ? parseInt(this.flyingCinemaNum) : 0
        data.chairNum = this.chairNum ? parseInt(this.chairNum) : 0
        if (data.flyingCinemaNum > this.maxProjectNum_f || data.chairNum > this.maxProjectNum_c) {
          return this.$message.error('场馆预约数量超过最大值，请核对后重新填写')
        }
      }
      if (this.isFid) { //微服务新的接口
        this.$ajax.post('/api/ticket/front/order/temp', data).then((res) => {
          this.hasClick = false
          let query = this.$route.query
          query.orderId = res.data
          this.$router.push({ path: '/ticket/re_success', query })
        }).catch((err) => {
          this.hasClick = false
        })
        return
      }
      this.$ajax.post('/api/ticket/front/order', data).then((res) => {
        this.hasClick = false
        let query = this.$route.query
        query.orderId = res.data
        this.$router.push({ path: '/ticket/re_success', query })
      }).catch((err) => {
        this.hasClick = false
      })
    },

    getPeopleInfo(id, type) {
      this.$ajax(`/api/ticket/front/people/info?museumCode=${this.museumCode}&belongId=${id}&personType=${type}`).then((res) => {
        switch (type) {
          case 1: //团队人员列表
            this.personals = res.data
            break;
          case 2:
            this.personals = res.data
            break;
          case 3: //团队人员列表
            this.childs = res.data
            break;
          case 4: //团队人员列表
            this.team = res.data
            break;
        }
      })
    },

    selectedHasChild(val) {
      this.getPeopleInfo(this.belongId, 3)
      this.hasChild = val
    },

    getTicketDetail() {

      if (this.$store.state.ticketDetail.id) {
        if (!this.$route.query.type) {
          this.reservationType = this.$store.state.ticketDetail.perOn ? 1 : 2
        }
        this.fillChildrenInfo = !this.isFid ? true : this.$store.state.ticketDetail.fillChildrenInfo
        return this.setTime()
      }
      let url = this.$route.query.code ? `/api/ticket/front/ticket-info/code?museumCode=${this.$route.query.museumCode}&code=${this.$route.query.code}` : `/api/ticket/front/ticket-info?museumCode=${this.$route.query.museumCode}${this.$route.query.id ? `&ticketInfoId=${this.$route.query.id}` : ''}`
      this.$ajax.get(url).then((res) => {
        this.$store.state.ticketDetail = res.data[0]
        this.fillChildrenInfo = !this.isFid ? true : this.$store.state.ticketDetail.fillChildrenInfo
        if (!this.$route.query.type) {
          this.reservationType = this.$store.state.ticketDetail.perOn ? 1 : 2
        }
        this.setTime()
      })
      // console.log('this.$store.state.ticketDetail')
      // console.log(this.$store.state.ticketDetail)
    },
    // isCurrentTimeAfter530_2400PM() {
    //   const now = new Date();
    //   const hour = now.getHours();
    //   const minutes = now.getMinutes();

    //   // 将当前时间转换为小时和分钟
    //   const nowHour = hour + minutes / 60; // 将分钟转换为小时

    //   // 目标起始时间是17:30
    //   const targetHour = 1 + 30 / 60;
    //   // 目标截止时间是17:30
    //   const targetEndHour = 24 + 0 / 60;
    //   console.log('x1')
    //   console.log(nowHour)
    //   console.log(targetHour)
    //   console.log(targetEndHour)

    //   // 比较当前时间和目标时间
    //   return (nowHour >= targetHour && nowHour <= targetEndHour);
    // },

    isCurrentlyBetween(start, end) {
      let now = new Date();
      // console.log('xxxxxxxxxxxxxx')
      // console.log(start)
      // console.log(end)
      // now.setHours(18);
      // now.setMinutes(30);
      // now.setSeconds(0);
      // now.setMilliseconds(0);
      // console.log(now)

      return now >= start && now <= end;
    },




    setTime() {
      let nowDate = new Date()
      let date = new Date()
      this.calendar1.begin = []


      let addOne = 0

      // 设置时间范围
      let startTimex = new Date().setHours(17, 30, 0, 0); // 下午17.30
      let endTimex = new Date().setHours(24, 0, 0, 0);   // 次日凌晨24.00

      // 判断当前时间是否在这个时间范围内
      let isNowBetween = this.isCurrentlyBetween(startTimex, endTimex);
      console.log('isNowBetween'); // 如果当前时间在下午17.30到24.00之间，将打印true，否则打印false
      console.log(isNowBetween); // 如果当前时间在下午17.30到24.00之间，将打印true，否则打印false
      if (this.museumCode == 212594 && this.reservationType == 2) {
        if (isNowBetween) {
          addOne = 1
        } else {
          addOne = 0
        }
      }
      console.log('add')
      console.log(addOne)
      let advanceBookingDays = this.$store.state.ticketDetail.advanceBookingDays ? (this.$store.state.ticketDetail.advanceBookingDays * 1) * 24 * 60 * 60 * 1000 : 0
      if (this.museumCode == 212594 && this.reservationType == 2) {
        advanceBookingDays = (1 + addOne) * 24 * 60 * 60 * 1000
      }

      let startDate = nowDate.getTime() + advanceBookingDays
      // let startDate = nowDate.getTime()
      startDate = new Date(nowDate.setTime(startDate))
      let endDate = date.getTime() + (this.$store.state.ticketDetail.bookingDays ? this.$store.state.ticketDetail.bookingDays - 1 : -1) * 24 * 60 * 60 * 1000 + advanceBookingDays
      endDate = new Date(date.setTime(endDate))
      let end = [`${endDate.getFullYear()}`, `${endDate.getMonth() + 1}`, `${endDate.getDate()}`]
      this.calendar1.end = end
      this.calendar1.events = {
        hasClose: !this.$store.state.ticketDetail.dateClose && !this.$store.state.ticketDetail.customCloseStart ? false : true,
        week: this.$store.state.ticketDetail.dateClose ? this.$store.state.ticketDetail.dateClose.split(',') : '',
        customCloseEnd: this.$store.state.ticketDetail.customCloseEnd ? new Date(this.$store.state.ticketDetail.customCloseEnd) : '',
        customCloseStart: this.$store.state.ticketDetail.customCloseStart ? new Date(this.$store.state.ticketDetail.customCloseStart) : '',
        customCloseDate: this.$store.state.ticketDetail.customCloseDate ? this.$store.state.ticketDetail.customCloseDate : '',
        advanceBookingDays: advanceBookingDays
      }
      console.log(this.calendar1)
      this.$nextTick(() => {
        this.calendar1.begin = [`${startDate.getFullYear()}`, `${startDate.getMonth() + 1}`, `${startDate.getDate()}`]
      })
    },

    hasRead() {
      if (this.showExplaxinInfo) {
        return this.showExplaxinInfo = false
      }
      if (this.readTime) return
      this.showNotice = false
      this.hasReadNotice = true
      this.hasOpenNotice = true
    },

    // 获取个人信息（type为2的信息）
    getUserInfo() {
      // 获取手机号
      this.$ajax('/api/ticket/front/people/get-phone').then((res) => {
        this.$store.state.userPhone = res.data
        this.$ajax(`/api/ticket/front/people/belong-info?museumCode=${this.museumCode}&personType=2`).then((res) => {
          let t = !res.data || !res.data.length
          if (!t) return this.getUserInfoDetail(res.data[0].id)
          //没有过常用联系人
          if (this.$route.query.type) {
            this.reservationType = parseInt(this.$route.query.type)
          }
          if (this.$store.state.userPhone) {
            this.addDetail.phone = this.$store.state.userPhone
            this.addDetail.phoneDisabled = true
          }
          this.handelShowAdd(true, 'personal', 'addUserInfo')
        })
      })
    },

    // 根据id获取未脱敏的数据
    getUserInfoDetail(id) {
      this.$ajax.get(`/api/ticket/front/people/get-by-id?id=${id}`).then((res) => {
        res = res.data
        this.userInfo = res
        if (this.$route.query.type) {
          this.reservationType = parseInt(this.$route.query.type)
        }
      })
    },

    // 获取常用团队
    getCommonInfo(id) {
      this.$ajax.get(`/api/ticket/front/people/common?museumCode=${this.museumCode}&type=2`).then((res) => {
        this.belongData = res.data
        if (!this.belongData.length) this.addNewGroup()
        if (this.belongData.length) this.selectGroup(this.belongData[0])
        if (this.belongData.length && !this.$cookie.get('ticket_phone')) {
          var pat = /(\d{3})\d*(\d{4})/;
          let phone = this.belongData[0].phone.replace(pat, '$1****$2');
          this.$cookie.set('ticket_phone', phone)
        }
      })
    },

    // 获取讲解说明
    getNoticeInfo() {
      this.$ajax(`/api/admin/front/dict/codeDictAll/jjsm?museumCode=${this.museumCode}`).then((res) => {
        this.explainInfo = res.data.description
      })
    }
  },

  mounted() {
    this.museumCode = this.$route.query.museumCode || this.$cookie.get('museumCode')
    // 金湾区博物馆讲解说明
    if (this.museumCode == 212594 || this.museumCode == '200090') {
      this.getNoticeInfo()
    }
    this.getTicketDetail()
    this.getUserInfo()
    console.log('tick')
    console.log(this.$store.state.ticketDetail)
    // this.$store.state.userPhone = '18865916211'
  },

  created() {
    this.isFid = !isNaN(Number(this.$route.query.museumCode)) ? true : false
  },

  computed: {
    maxPersonal() {
      return this.$store.state.ticketDetail.bookingDayMax || 3
    }
  },

  watch: {
    showAdd: {
      handler(val, valOld) {
        if (!val) {
          this.addDetail = {}
        }
      }
    },
    reservationType: {
      handler(val, valOld) {
        this.certificate = []
        this.personals = []
        val == 1 ? this.getBelongInfo() : this.getCommonInfo()
        this.hasOpenNotice = false
        this.hasReadNotice = false
        this.getTimeDetail()
        // if (val * 1 == 2) {
        //   console.log('this.$store.state.ticketDetail')
        //   console.log(this.$store.state.ticketDetail)
        //   this.setTime()
        // }
        this.setTime()
      }
    },
    selectedDate: {
      handler(val, valOld) {
        this.getTimeDetail()
      }
    },
    showNotice: {
      handler(val, valOld) {
        if (val) {
          if (this.hasOpenNotice) return
          this.readTime = 3
          timeInterval = setInterval(() => {
            if (!this.readTime) return clearInterval(timeInterval)
            this.readTime--
          }, 1000)
        }
      }
    },
    showAddNewGroup: {
      handler(val, valOld) {
        if (val == false && this.belongData.length && !this.selectGroupId) {
          this.selectGroup(this.belongData[0])
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.reservation {
  width: 10rem;
  overflow: hidden;
  &.onPage {
    overflow: hidden;
    height: 100vh;
  }
  .explainPerNumInput{
    width: 280px;
    // margin-left: 40px;
    transform: translateY(5px);
    display: inline-block !important;
  }
  // 移动端常用团队
  .mobileGroups {
    margin-left: -0.3rem;
    width: calc(100% + 0.5rem);

   /* .nameBlock {
      padding: 0 0.35rem !important;
      margin: 0 0.3rem !important;
      margin-bottom: 0.5rem !important;
    }
    */

    // .nameBlock:nth-child(3n-1){
    //   margin: 0 0.9rem;
    // }
  }

  &.reservation_mobile {
    .noticeLine {
      align-items: center;
      justify-content: center;
      margin-bottom: 0.89rem;

      .notice {
        font-size: 0.364rem;
        color: #999;
      }

      .noticeText {
        transform: scale(0.85);
        color: #999;
        margin-left: 0;
      }
    }

    .itemCard {
      margin: 0.5rem 0.3rem;
      background: #fff;
      padding-top: 2.5rem;
      position: relative;

      &:before {
        position: absolute;
        content: '';
        display: inline-block;
        top: 0.08rem;
        left: 0.08rem;
        width: 9.24rem;
        height: 1.2rem;
        background: linear-gradient(180deg, #FCEDD1 0%, #FFFAF2 0.01%, rgba(248, 240, 227, 0.00) 100%);
        border-radius: 0.416rem 0.416rem 0px 0px;
      }

      &.explain,
      &.certificate {
        padding: 1.5rem 0.65rem 0.8rem 0.65rem;
        box-shadow: 0px 0.1rem 0.26rem 0px rgba(0, 0, 0, 0.08);
      }

      .itemCardTitle {
        position: absolute;
        left: 0.65rem;
        top: 0.5rem;
        font-size: 0.494rem;
      }

      &.certificate {
        // display: flex;
        // align-items: center;
        line-height: 0.75rem;

        .uploadImgs {
          color: #666666;
          margin-top: 0;
          line-height: unset;
          // height: 0.6rem;
          font-size: 0;
          // display: block;
          margin-top: 0.7rem;
        }

        .uploadButtonMobile {
          transform: translateY(-0.1rem);
        }
      }
    }

    .calendarWarp {
      padding-top: 1.5rem;
      margin: 0.3rem;
      position: relative;
      background-color: #fff;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.08);
      border-radius: 0.416rem;
    }
  }

  // pc端
  &.isPc {
    position: relative;
    padding-bottom: 0.5rem;

    // pc背景图
    .pcBg {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('../../assets/ticket/re_bg.png') left bottom/cover no-repeat;
      z-index: -1;
    }
  }

  .itemWarpType {
    margin: -1.5rem 0.3rem 0.49rem 0.3rem;
    padding: 0.52rem 0;
    background: #FFFDFA;
    border-radius: 0.416rem;
    font-size: 0;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.08);

    div {
      width: 4rem;
      height: 0.9rem;
      display: inline-block;
      font-size: 0.572rem;
      line-height: 0.9rem;
      position: relative;

      // border: 0.01rem solid #333333;
      &.activeType {
        &:after {
          position: absolute;
          background: #E1CDCF;
          width: 2.73rem;
          height: 0.156rem;
          border-radius: 0.078rem;
          content: '';
          display: inline-block;
          bottom: 0.04rem;
          left: 0.64rem;
        }
      }
    }

    div:nth-child(2) {
      margin-left: 0.69rem;
    }
  }

  .bigImg {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: #333;
    top: 0;
    left: 0;
    z-index: 22;

    .placeholder {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 21;
    }

    .imgWarp {
      width: 100%;
      height: 80vh;
      margin: 10vh auto;
    }

    img {
      object-fit: contain;
      height: 100%;
      width: 100%;
    }
  }

  .members {
    margin: 0.5rem 0.6rem;
    display: flex;
    justify-content: space-between;
    font-size: 0.5rem;
    font-weight: 500;
  }

  .explainInfo {
    font-size: 0.42rem;
    text-align: left;
    margin: 0.3rem 0 0.3rem 0;
  }

  .fileDemo {
    font-size: 0.4rem;
    text-align: left;
    margin-left: 0.7rem;
    margin-bottom: 0.5rem;
  }

  .explain,
  .certificate {
    // display: flex;
    // justify-content: flex-start;
    // align-items: center;
    text-align: left;
    padding: 0.3rem 0.5rem;

    .contentTitle {
      display: inline-block;
    }

    .upload-demo {
      display: inline-block;
    }
  }

  // 移动端
  .buttonGroupMobile {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    cursor: pointer;
    text-align: center;
    margin-top: 0.8rem;
    padding-bottom: 0.6rem;

    // transform: translateY(-0.5rem);
    .addGroup {
      width: 50%;
      line-height: 1.17rem;
      font-size: 0.49rem !important;
      letter-spacing: 0.1em;
      padding-top: 0;
      height: 1.17rem;
      font-size: 0.2rem;
      padding: 0 0.1rem;
      border-radius: 0.416rem 0.416rem 0 0;
      background: #ffffff;
      border: unset;
      box-shadow: 0px -0.052rem 0.078rem 0px rgba(0, 0, 0, 0.08);

      &:before {
        display: none;
      }

      padding-left: 0;

      &.gray {
        height: 0.88rem;
        line-height: 0.88rem;
        font-size: 0.442rem !important;
        background: #fff;
        color: #333;
        background: #F4EDDF;
        padding-bottom: 0;
        border-radius: 0 0.416rem 0 0.416rem;
      }

      &:first-child.gray {
        border-radius: 0.416rem 0 0.416rem 0;
      }
    }
  }

  .uploadButtonMobile {
    width: 1.77rem;
    height: 0.65rem;
    line-height: 0.65rem;
    font-size: 0.312rem;
    display: block;
    position: relative;
    display: inline-block;
    color: #fff;
    border-radius: 0.1rem;
    margin-left: 0.5rem;

    div {
      position: absolute;
      top: 1.2rem;
      font-size: 0.2rem;
      width: calc(100% - 0.2rem);
      line-height: 0.36rem;
      padding: 0 0.1rem;
    }
  }

  .certificate .uploadImgs {
    margin-top: 0.5rem;
    width: 32%;
    height: 32vw;
    margin-right: 1%;
    position: relative;
    display: inline-block;
    vertical-align: top;
  }

  .certificate .uploadImgs img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    overflow: hidden;
  }

  .certificate .uploadImgs span {
    height: 0.8rem;
    width: 0.8rem;
    position: absolute;
    top: -0.5rem;
    left: 0rem;
    background: url('../../assets/close_fill.png') 0 0/100% 100% no-repeat;
  }

  .isMobile .upload-demo {
    margin-top: -0.15rem;
  }

  .pcItemCard {
    .explain {
      margin: 0.2rem 0;
      padding: 0;
      padding-left: 45px;
      margin-right: 30px;
      vertical-align: middle;

      // justify-content: flex-start;
      &:before {
        left: 0px;
      }
    }

    .el-radio-group {
      margin-top: 0 !important;
      margin-right: 60px;
    }

    .buttonGroup {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px 0;
      margin-bottom: 30px;
      cursor: pointer;

      .addPcGroup {
        &::before {
          display: none;
        }

        padding: 0 20px;
        margin-bottom: 0;
        padding-bottom: 15px;

        &:first-child {
          margin-right: 200px;
        }
      }

      .gray {
        color: #333333;
        border-bottom: 4px solid rgba(0, 0, 0, 0);
        // opacity: 0.5;
      }
    }

    .addGroup {
      &:before {
        display: none;
      }

      padding-left: 0;
      color: #fff;
    }

    .explainInfo {
      font-size: 20px;
      text-align: left;
      // margin: 0 0 0 85px;
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
    }
  }

  .button3 {
    margin: auto;
  }

  .closeReservation {
    font-size: 0.42rem;
    margin-bottom: 0.5rem;
    // margin-top: -0.7rem;
  }

  .timeInSelected {
    font-size: 0.4rem;
    width: 5.1rem;
    text-align: left;
    position: relative;
    padding: 0.25rem 0.2rem;
    background: #fff;
    border-radius: 0.2rem;
    text-align: center;

    &::after {
      display: inline-block;
      content: '';
      position: absolute;
      top: 0.28rem;
      right: 0.2rem;
      width: 0.45rem;
      height: 0.4rem;
    }
  }

  .calendarWarp {
    // height: 9rem;
    margin: 0.3rem;
    position: relative;
    background-color: #FFFDFA;
    padding-top: 1rem;
    border-radius: 0.416rem;

    &:after {
      position: absolute;
      height: 1.508rem;
      width: 9.2rem;
      left: 0.12rem;
      top: 0.12rem;
      background: linear-gradient(180deg, #FCEDD1 0%, #FFFAF2 0.01%, rgba(248, 240, 227, 0.00) 100%);
      content: '';
      display: inline-block;
      border-radius: 0.416rem;
    }

    .calendarDetail {
      padding: 0.3rem 0;
      border-radius: 0.3rem;
    }
  }

  .buttonLine {
    width: 100%;
    margin: auto;
    position: relative;

    div {
      display: inline-block;
    }

    .buttonRed {
      margin-right: 0.5rem;
    }

    .pcToIndex {
      position: absolute;
      top: 10px;
      left: 20px;
      color: #666;
    }
  }

  .line {
    font-size: 24px;
    font-weight: 500;
    text-align: center;
    line-height: 36px;
    margin: 35px 0;

    span {
      margin-left: 0.2rem;
      font-size: 22px;
    }
  }

  .pcCalendar {
    width: 1040px;
    position: relative;

    .mouthText {
      font-size: 25px;
      position: absolute;
      top: 156px;
      right: -100px;
      color: #fff;
      z-index: 222
    }
  }

  .popWarp .tips {
    font-size: 18px;
    line-height: 36px;
    margin-top: 15px;
    text-align: left;
    margin-left: 30px
  }

  .pcItemCard {
    text-align: left;

    .closeReservation {
      margin-top: 0.5rem;
      font-size: 0.18rem;
    }
  }

  .timeAndTicket {
    display: inline-block;
    font-size: 0.1rem;
    width: 1.3rem;
    height: 0.42rem;
    line-height: 0.42rem;
    margin-right: 0.55rem;
    margin-bottom: 0.1rem;
    border: 1px solid #d2d2d2;
    text-align: center;
    border-radius: 0.1rem;
    cursor: pointer;
    background-color: #fff;
  }

  .selectedTime {
    // background: url('~@/assets/ticket/buttonSelect.png') 0 0/contain no-repeat;
    // border: unset;
    width: 1.31rem;
    height: 0.42rem;
  }

  .buttonsWarp {
    // padding: 0 2.5rem;
  }

  .groupItem {
    font-size: 20px;
    border: 1px solid #fff;
    background-color: #fff;
    min-width: 208px;
    text-align: center;
    height: 68px;
    line-height: 68px;
    padding: 0 10px;
    border-radius: 16px;
    display: inline-block;
    margin-right: 28px;
    margin-bottom: 28px;
    cursor: pointer;
    border: 1px solid #d2d2d2;

    &:nth-child(4n+1) {
      margin-right: 0;
    }
  }

  .addNewGroup {
    font-size: 0.45rem;
    text-align: left;
    margin-left: 0.8rem;
    margin-bottom: 10px;
  }

  .popHasRead {
    font-size: 20px;
    width: 160px;
    height: 52px;
    line-height: 52px;
    margin-top: 30px;
  }

  .gayText {
    opacity: 0.9;
    background: #999 !important;
  }

  .popNoticeContent {
    overflow-y: scroll;
    height: 500px;
  }

  .popContentTitle {
    font-size: 36px;
    text-align: center;
    font-weight: 500;
    margin-bottom: 40px;
  }

  .popNotice {
    font-size: 24px;
    line-height: 36px;

    // overflow: scroll;
  }

  .pcStopTime {
    display: inline-block;
    margin-left: 30px;
  }
}
</style>
<style type="text/css" lang="scss">
.itemContentTitle {
  margin: 0 0.7rem;
  font-weight: 500;
  font-size: 0.45rem;
  text-align: left;
}
.reservation .explainPerNumInput{
  .el-input__inner{
    color: #666666;
    width: 280px;
    text-align: left;
  }
}
.van-picker-column__wrapper .van-ellipsis {
  width: 90% !important;
  padding-left: 30% !important;
  text-align: left !important;
}

.reservation {
  .otherH5Project {
    .hasProject {
      margin-bottom: 1.8rem;
      position: relative;
    }

    .projectTitle {
      display: inline-block;
    }

    .projectWarp {
      position: absolute;
      left: 0;
      top: 0.8rem;
      text-align: left;
    }

    .el-input {
      width: 2.2rem;
    }

    .itemWarp {
      height: auto
    }

    .el-input__inner {
      height: 0.8rem;
      line-height: 0.8rem;
      color: #000;
      border: 1px solid #DCDFE6;
      margin-bottom: 0.2rem;
    }
  }

  &.reservation_mobile {
    .noticeLine .el-checkbox__inner {
      background: rgba(0, 0, 0, 0);
    }

    .itemCard {
      padding: 0.5rem 0.65rem;
    }

    .personal {
      .itemCard {
        background: #fff;
        margin: 0.5rem 0.3rem;
        position: relative;
        border-radius: 0.416rem;
        padding: 0.6rem;
        padding-top: 1.8rem;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.08);

        &:before {
          position: absolute;
          content: '';
          display: inline-block;
          top: 0.12rem;
          left: 0.12rem;
          width: 9.2rem;
          height: 1.2rem;
          background: linear-gradient(180deg, #FCEDD1 0%, #FFFAF2 0.01%, rgba(248, 240, 227, 0.00) 100%);
          border-radius: 0.416rem 0.416rem 0px 0px;
        }

      }

      .nameWarp {
        font-size: 0;
      }

      .nameBlock {
        border: 0.026rem solid #999999;
        width: 2.16rem;
        padding: 0 0.1rem;
        overflow: hidden;
        vertical-align: top;
        white-space: nowrap;
        text-overflow: ellipsis;

        &:nth-child(3n-1) {
          margin: 0 0.48rem;
        }

        &.selected {
          color: #ffffff;

          &:after {
            width: 0.7rem;
            height: 0.52rem;
            bottom: 0;
            right: -0.03rem;
            background: url('../../assets/ticket/selected.png') 0 0/ contain no-repeat;
            -webkit-mask: unset;
            mask: unset;
          }

          &:before {
            position: absolute;
            content: '';
            display: inline-block;
            width: 0.25rem;
            height: 0.2rem;
            bottom: 0.05rem;
            right: 0.1rem;
            z-index: 22;
          }
        }
      }

      .itemContentTitle {
        margin: 0 0 0.7rem 0;
        z-index: 1;
        position: absolute;
        left: 0.6rem;
        top: 0.5rem;
      }
    }

    .child {
      .itemCard {
        padding-top: 1.5rem;
        padding-bottom: 0.4rem;

        .itemWarp {
          position: absolute;
          top: 0.55rem;
        }
      }
    }

    .calendarWarp {
      position: relative;
      padding-top: 1.5rem;

      .calendarTopIcon,
      &:before {
        position: absolute;
        content: '';
        display: inline-block;
        width: 0.39rem;
        height: 0.78rem;
        top: -0.27rem;
        left: 1rem;
        z-index: 222;
        background: url('../../assets/ticket/calendar-top.png') 0 0/contain no-repeat;
      }

      &:before {
        left: unset;
        right: 1rem;
      }

      // calendar-top
    }

    .calendar table {
      width: 90%;
      margin: 0 5%;
    }

    .calendar {
      td.selected:after {
        height: 1.4rem;
        border-radius: 0.156rem;
      }

      td .text {
        font-size: 0.24rem;
        top: 0.11rem;
      }
    }

    .mobileGroupWarp {
      // background: #FFFDFA;
      margin: 0 0.3rem;
      border-radius: 0.416rem;
      margin-top: 1rem;
      box-shadow: 0px 0.156rem 0.26rem 0px rgba(0, 0, 0, 0.08);

      .itemCard {
        margin: 0 0 0.5rem 0;
        background: #fff;
        padding-top: 1.8rem;
        // box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.08);
      }

      .lineContent {
        font-size: 0.44rem;

        .name {
          width: 3.8rem;
        }

        .el-input__inner {
          font-size: 0.42rem;
        }

        input {
          border: 0.013rem solid #333333;
        }

        .el-input.is-disabled {
          input {
            border: 0;
          }
        }
      }
    }

    .itemCard {
      border-radius: 0.416rem;

      .el-radio-group {
        margin-left: 0.4rem;
      }
    }

    .itemCard {
      &.certificate {
        el-upload {
          height: 0.65rem;
        }
      }
    }
  }
}

.otherPcProject {
  position: relative;

  .projectWarp {
    display: flex;
    align-items: center;
    margin-top: 5px;
    position: absolute;
    bottom: 30px;
  }

  .projectTitle {
    display: inline-block;
    font-size: 18px;
    width: auto;
    margin-left: 40px;
  }

  .el-input {
    width: 100px;
  }

  .el-input__inner {
    color: #000;
    border: 1px solid #DCDFE6;
  }
}

.reservation {
  .itemWarp {
    display: flex;
    align-items: center;
    font-size: 0.45rem;
    font-weight: 500;
    height: 0.9rem;
  }

  .itemWarpTime {
    display: flex;
    // justify-content: center;
    align-items: center;
    font-size: 0.45rem;
    font-weight: 500;
    height: 0.9rem;

    &.timeWarp {
      margin-bottom: 0.2rem;
    }

    .contentTitle {
      margin-left: 0.6rem;
    }
  }

  .pcContent {
    .nameBlock {
      border: 1px solid #d2d2d2;
    }

    .nameWarp {
      margin-top: 0.15rem;
    }

    .add {
      font-size: 27px;
    }

    .contentTitle {
      font-size: 26px;
    }

    .certificate {
      display: flex;
      justify-content: flex-start;
      text-align: left;
      align-items: center;
      padding: 0;
      margin: 0;
      font-size: 26px;
      height: 50px;
      margin-top: 0;

      .contentTitle {
        padding-left: 45px;
        line-height: 50px;
      }

      .contentTitle:before {
        top: 10px;
        left: 0px;
        // display: none;
      }
    }

    .fileDemo {
      margin-left: 0.5rem;
    }

    .uploadImgs img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      overflow: hidden;
    }

    .uploadImgs {
      margin-top: 0.5rem;
      margin-right: 1%;
      position: relative;
      display: inline-block;
      vertical-align: top;
      width: 10%;
      height: 1rem;
      margin-top: 0.2rem;
      cursor: pointer;
    }

    .uploadImgs span {
      position: absolute;
      background: url('../../assets/close_fill.png') 0 0/100% 100% no-repeat;
      top: -0.15rem;
      left: -0.05rem;
      height: 0.2rem;
      width: 0.2rem;
      cursor: pointer;
    }

    .fileDemo {
      font-size: 20px;
      margin-bottom: 0;
      cursor: pointer;
    }
  }
}

.reservation .pcCalendar {
  tr {
    margin-bottom: 20px;
    padding-bottom: 10px;
  }

  thead {
    tr {
      padding-bottom: 0;
      margin-bottom: 0;
    }
  }

  th {
    width: 134px !important;
  }

  td {
    width: 134px !important;

    &.week {
      color: #391F1F;
    }
  }

  .jiantou {
    // background: url('../../assets/ticket/jiantou.png') 0 0/contain no-repeat;
    width: 35px;
    height: 35px;
    z-index: 333;
    margin: 20px;
    left: 336px;
    top: -78px;
    cursor: pointer;
  }

  .jiantouRight {
    left: 605px;
    // transform: rotate(180deg);
  }

  .calendar thead {
    border-radius: 8px;
    background: rgba(15, 53, 103, 0.05);
    padding: 0 40px;
    width: auto !important;
  }

  .calendar tbody {
    padding: 0 40px;
    padding-top: 20px;
  }

  .calendar thead tr {
    background: rgba(0, 0, 0, 0);
    width: auto;
  }

  .calendar td.week {
    font-size: 24px;
    height: 60px;
    line-height: 60px;
  }

  .calendar td span {
    font-size: 20px;
  }

  .calendar td {
    height: 55px;
    cursor: pointer;
    margin: 0 !important;
  }

  .calendar-info>div.month {
    width: 200px !important;
    margin-top: 0 !important;
  }

  .calendar-info>div.month .month-inner>span {
    width: 200px !important;
    height: 100px;
    text-align: center;
  }

  tr,
  thead,
  .swiper-container,
  .swiper-wrapper,
  .swiper-slide {
    width: 100% !important;
    // background-color: #fff;
  }

  tbody {
    padding-bottom: 5px;
    // background-color: #fff;
  }

  table {
    color: #268775;
  }

  .calendar tbody td {
    margin-bottom: 10px !important;
  }

  .calendar-tools {
    top: unset;
  }

  .calendar td span {
    margin: 15px auto 0 auto;
    height: 26px;
    line-height: 26px;
  }

  .calendar td .text {
    width: 100%;
    padding: 2px;
  }

  .calendar td.selected::after {
    left: 37px;
    width: 60px;
    height: 65px;
    top: 5px;
    border-radius: 8px;
  }

  .calendar-info>div.month {
    height: 32px;
    line-height: 32px;
    // right: 140px;
    // position: absolute;
  }

  .calendar-info>div.month .month-inner {
    color: #fff;
    left: 10px;
  }

  .calendar-info>div.yearText {
    font-size: 26px;
    width: 120px;
    height: 40px;
    margin-top: 13px;
    font-weight: bold;
    position: absolute;
    // color: #fff !important;
  }

  .calendar {
    padding-top: 50px;
  }
}

.buttonLine .el-input__inner {
  height: 0.28rem;
  line-height: 0.28rem;
}

.timeDetail {
  margin-top: 35px;
}

.reservation .pcItemCard {
  .timeDetail {
    .timeAndTicket {
      width: 228px;
      height: 68px;
      margin-right: 28px;
      border-radius: 15px;
      margin-bottom: 28px;
      font-size: 20px;

      div {
        line-height: 30px;
        padding-top: 8px;

        &:nth-child(2) {
          line-height: 20px;
          font-size: 16px;
          padding-top: 0px;
        }
      }

      &:nth-child(4n+1) {
        margin-right: 0;
      }

      &.oneLine {
        div {
          line-height: 68px;
          padding: 0;
        }
      }
    }

    .selectedTime {
      width: 226px;
      line-height: 66px;
      height: 66px;
      background-size: 100% 100%;
    }
  }

  .left,
  .right {
    overflow: auto;
  }

  .lineBgc {
    margin: 30px 0;
    padding: 40px 80px;
    background-color: #fff;
    border-radius: 16px;
    position: relative;

    &:after {
      position: absolute;
      display: inline-block;
      width: 3px;
      height: 80%;
      content: "";
      top: 10%;
      left: calc(50% - 1px);
    }
  }
}

.reservation .buttonsWarp {
  margin-top: 30px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  .upload-demo,
  .button3 {
    width: 315px;
    height: 65px;
  }

  .button3 {
    margin: 0 !important;
  }
}

.reservation .popNotice p {
  margin: 0;
}

.reservation .pcContent .lineBgc {
  .lineContent {
    margin: 2px 0;
  }

  .lineContent .el-input__inner {
    font-size: 18px;
    padding: 15px;
  }

  .lineContent .name {
    width: 145px;
  }

  .lineContent .name.nameSpace {
    letter-spacing: 0.24em
  }

  .lineContent .el-input {
    width: 270px;
    border-radius: 6px;
  }

  .left {
    .lineContent:first-child {
      margin-bottom: 15px;

      .el-input {
        border: 1px solid #E3E3E3;
      }
    }
  }

  .right {
    .lineContent:first-child {
      margin-bottom: 15px;
    }
  }
}

.reservation .pcContent {
  .teamNumber .itemWarpLine {
    min-height: 60px;
  }

  .teamNumber {
    box-shadow: unset;
  }

  .buttonsWarp {
    margin-bottom: 50px;
  }

  .lineContent {
    .name span {
      width: 40px;
      display: inline-block;
    }
  }
}

.reservation .pcContent .pcItemCard .left,
.reservation .pcContent .pcItemCard .right {
  width: 380px;
}

.reservation .popNoticeContent {
  .popNotice {
    width: 100%;
    text-align: left;
    font-size: 24px;
  }

  p,
  h3,
  pre {
    white-space: normal;
    width: 100%;
    margin-block-start: 0;
    margin-block-end: 0;
  }

  p {
    margin: 10px 0 !important;
  }
}

.reservation .noticeWarp {
  .noticeDetail {
    text-align: left;
  }

  pre {
    white-space: normal;
  }
}

.reservation .certificate .el-upload {
  cursor: auto
}

.reservation .popContent .lineContent .el-input__inner {
  font-size: 20px;
  border-radius: 8px;
  border: 1px solid #E4E2E0;
  line-height: 55px;
  height: 55px;
}
</style>
